import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { useNavigate } from "@shared/react-router-dom";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import { noStyleButton, chevron } from "./ReturnToSignInButton.styles";

const ReturnToSignInButton: FC = ({ ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Button noStyle onClick={handleGoBack} css={noStyleButton} {...rest}>
      <FontAwesomeIcon className="icon-chevron" icon={faChevronLeft} size="sm" css={chevron} />
      {t(l.signIn.ReturnToSignIn)}
    </Button>
  );
};

export { ReturnToSignInButton };
